var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-mouse"},[_c('div',{staticClass:"icon"},[_c('l-img',{attrs:{"src":_vm.src}})],1),_c('span',{staticClass:"tip"},[_vm._v("\n      向下滚动\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }